export default [
  {
    title: 'Dashboards',
    icon: 'ActivityIcon',
    route: 'dashboard-fbr',
    action: 'read',
    resource: 'Dash',
   
  },
]
